import type {
  DirectoryUser,
  MatterRole,
  PhaseActionTaskTemplate,
} from "@/lib/types";
import { formatUsersName } from "@/lib/utils/format";

export function taskPersonLabel(
  template: PhaseActionTaskTemplate,
  kind: "assignee" | "assigner",
  roles: MatterRole[],
  users: DirectoryUser[],
): string {
  const roleId =
    kind === "assignee" ? template.assigneeRoleId : template.assignerRoleId;
  const userIds =
    kind === "assignee" ? template.assigneeUserIds : template.assignerUserIds;

  if (roleId) {
    return roles.find((role) => role.id === roleId)?.label ?? "Matter role";
  }
  if (!userIds.length) return "Unassigned";

  const names = userIds.map((id) => {
    const user = users.find((item) => item.id === id);
    return user ? (formatUsersName(user) ?? "User") : "User";
  });
  return names.join(", ");
}

export function taskBackupLabel(
  userId: string | null | undefined,
  users: DirectoryUser[],
): string | null {
  if (!userId) return null;
  const user = users.find((item) => item.id === userId);
  return user ? (formatUsersName(user) ?? "User") : "User";
}
